import { lazyVue } from "@/utils";
export default [
    {
        path: '/evaluateService',
        name: 'evaluateService',
        title: '评价订单',
        component: lazyVue('evaluateService/service/index'),
        meta: {
            title: '评价订单',
            name: '评价订单',
            isKeepAlive: true,
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/evaluateService/index.js